<main class="container-fluid s-grid-section mb-5 p-3">
    <div class="mt-3 mb-4 d-flex justify-content-between align-items-center">
        <div class="font-weight-bold">
            <h1>Referrals</h1>
        </div>
        <div class="d-flex mt-2 ">
            <button mat-raised-button class="action-button referral-add-button"
            [routerLink]="['./add']">
            <mat-icon>add</mat-icon>
            Add Referral
        </button>
        </div>
    </div>
    <mat-card class="mt-3 pb-4">
        <div class="s-row s-grid-row-section">
            <div class="s-col-12">
                <div class="row justify-content-end p-3">
                    <div class="col-3 mt-3 mx-2">
                        <mat-form-field appearance="outline" class="search-bar">
                            <mat-label class="search-bar-label">
                                <mat-icon class="search-icon">search</mat-icon>
                                <span>Search</span>
                            </mat-label>
                            <input matInput (keyup)="applyFilter($event)" [(ngModel)]="filterValue">
                            <button type="button" *ngIf="filterValue" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                    <div class="mt-2 mb-3">
                        <div class="table-responsive">
                            <table class="mat-elevation-z8 referral-mat-table" mat-table [dataSource]="dataSource" matSort>
                                <ng-container matColumnDef="referralCode">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Code</th>
                                    <td mat-cell *matCellDef="let row" (click)="selection.toggle(row)"
                                        (click)="showDetail(row)">
                                        {{row.referralCode}} </td>
                                </ng-container>
                                <ng-container matColumnDef="legacyOrganizationId">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Payee</th>
                                    <td mat-cell *matCellDef="let row" (click)="selection.toggle(row)"
                                        (click)="showDetail(row)">
                                        {{row.legacyOrganizationId}}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="amount">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Commission</th>
                                    <td mat-cell *matCellDef="let row" (click)="selection.toggle(row)"
                                        (click)="showDetail(row)">
                                        <span *ngIf="row.percent == true && row.amount < 1">{{row.amount * 100}}%</span>
                                        <span *ngIf="row.percent == true && row.amount >= 1">{{row.amount}}%</span>
                                        <span *ngIf="row.percent == false">{{row.amount | currency}}</span>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="type">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Type </th>
                                    <td mat-cell *matCellDef="let row" (click)="selection.toggle(row)"
                                        (click)="showDetail(row)"> {{row.type}} </td>
                                </ng-container>
                                <ng-container matColumnDef="status">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Active </th>
                                    <td mat-cell *matCellDef="let row" (click)="selection.toggle(row)"
                                        (click)="showDetail(row)"> <mat-slide-toggle (click)="$event.stopPropagation()" [checked]="row.status === 'ACTIVE'"
                                        (change)="updateStatus($event, row)"></mat-slide-toggle>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="delete">
                                    <th mat-header-cell *matHeaderCellDef> </th>
                                    <td mat-cell *matCellDef="let row" (click)="selection.toggle(row)"
                                        (click)="showDetail(row)" style="text-align: center;">
                                        <button mat-mini-fab (click)="openDeleteDialog(row)"
                                            (click)="$event.stopPropagation()" style="align-self:center;background-color:red;color:white;" >
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row [ngClass]="{hovered: row.hovered, highlighted: selection.isSelected(row)}"
                                    (mouseover)="row.hovered = true" (mouseout)="row.hovered = false"
                                    *matRowDef="let row; columns: displayedColumns;"></tr>
                                <ng-container *ngIf="!loading.value">
                                    <tr class="mat-row" *matNoDataRow>
                                        <td class="mat-cell" colspan="12" style="padding:26px; text-align:center;">
                                            No data matching the "{{ filterValue }}"
                                        </td>
                                    </tr>
                                </ng-container>
                                @if(loading.value && filterValue) {
                                    <tr class="mat-row" *matNoDataRow>
                                        <td class="mat-cell" colspan="12" style="padding:26px; text-align:center;">
                                            No data matching the filter "{{ filterValue }}"
                                        </td>
                                    </tr>
                                }
                                @if (loading.value && !filterValue) {
                                    <tr class="mat-row" *matNoDataRow>
                                        <td class="mat-cell" colspan="12" style="padding:26px; text-align:center;">
                                            Loading Referrals..
                                        </td>
                                    </tr>
                                }
                            </table>
                        </div>
                        <div *ngIf="loading.value" class="d-flex justify-content-center">
                            <mat-spinner></mat-spinner>
                        </div>
                        <div class="d-flex paginator-row align-items-baseline">
                            <div class="col-10">
                                <mat-paginator (page)="onPageEvent($event)" [pageSizeOptions]="[10, 20, 50, 100]" [pageSize]="pageSize || 10" [length]="totalElements" aria-label="Select page" showFirstLastButtons></mat-paginator>
                            </div>
                            <div class="col-2 d-flex align-items-baseline">
                                <mat-form-field class="go-to" id="goToPage" style="width:90px;">
                                    <input type="number" matInput class="go-to-input" placeholder="Page" [(ngModel)]="pageNumber" step="1">
                                </mat-form-field>
                                <button mat-raised-button (click)="onGoToPageClick()" class="action-button">Go</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-card>
</main>